<div [class]="containerClass()">
  @if (label()) {
    <label
      class="checklist-task-label label"
      [class.sr-only]="hideLabel()"
      [attr.for]="id() || null">
      {{ labelText() }}
    </label>
  }

  <div class="relative">
    <ng-select
      appOpenOnValuePress
      [attr.id]="id() || null"
      [attr.name]="id() || null"
      [attr.data-testid]="testId() || null"
      [placeholder]="effectivePlaceholder()"
      [searchable]="searchable()"
      [clearable]="clearable()"
      [dropdownPosition]="dropdownPosition()"
      [appendTo]="appendTo()"
      [virtualScroll]="false"
      [multiple]="multiple()"
      [formField]="field()"
      [items]="parsedOptions()"
      [groupBy]="groupBy()"
      bindValue="value"
      bindLabel="label"
      [addTag]="allowNew() ? addNew : false"
      [closeOnSelect]="!multiple()"
      [clearSearchOnAdd]="true"
      class="checklist-input-select app-dropdown-select"
      [class.app-dropdown-tags]="tagSelection()"
      [class]="selectClass()"
      (open)="onNgSelectOpen()">
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span
          class="ng-value-icon left"
          (click)="clear(item)"
          aria-hidden="true"
          >&times;</span
        >
        <span class="ng-value-label">
          <div [attr.title]="item.label">
            {{ item.label }}
            @if (item.isNew) {
              <span
                class="app-dropdown-new-badge"
                data-testid="dropdown-new-badge"
                >New</span
              >
            }
          </div>
        </span>
      </ng-template>
      <ng-template ng-tag-tmp let-search="searchTerm">
        <span class="ng-option-label">{{ search }}</span>
        <span class="app-dropdown-new-badge">New</span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$">
        @if (multiple()) {
          <span
            class="app-dropdown-checkbox"
            [class.app-dropdown-checkbox-checked]="item$.selected"
            aria-hidden="true"
            data-testid="dropdown-option-checkbox"></span>
        }
        <span class="ng-option-label">
          <div [attr.title]="item.label">
            {{ item.label }}
            @if (item.isNew) {
              <span
                class="app-dropdown-new-badge"
                data-testid="dropdown-new-badge"
                >New</span
              >
            }
          </div>
        </span>
      </ng-template>
    </ng-select>
    @if (showError()) {
      <svg-icon
        src="/assets/svg/alert-circle.svg"
        class="absolute right-7 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none text-error-primary"
        svgClass="w-5 h-5" />
    }
  </div>
  @if (showError()) {
    <p class="text-error-primary m-0 p-0">{{ errorMessage() }}</p>
  }
</div>

@if (pickerOpen() && usesMobilePicker()) {
  <app-mobile-searchable-picker
    [title]="label()"
    [options]="parsedOptions()"
    [currentValue]="state().value()"
    [multiple]="multiple()"
    (commit)="onPickerCommit($event)"
    (cancel)="onPickerCancel()" />
}
